<template>
  <div>
    <common-dialog
      ref="dialog"
      width="400px"
      line-form
      show-save-button
      unit="付款方式"
      edit-title
      id-key="PayId"
      :data="data"
      @create-opened="onCreateOpened"
      :form-rules="rules"
      :save-func="api.save"
      @close-saved="$emit('close-saved')"
    >
      <template slot="form">
        <el-form-item label="付款方式" prop="PayName">
          <el-input v-model="data.PayName" placeholder="请输入付款方式名称" />
        </el-form-item>
        <el-form-item label="序号" prop="Sn">
          <el-input v-model="data.Sn" v-int style="width: 100px;" />
          <span class="t-tips">*值越小排得越前</span>
        </el-form-item>
        <el-form-item label="状态" prop="Status">
          <el-radio-group v-model="data.Status" class="detail-span">
            <el-radio :label="1">启用</el-radio>
            <el-radio :label="0">停用</el-radio>
          </el-radio-group>
        </el-form-item>
      </template>
    </common-dialog>
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
  },
  data() {
    return {
      data: {
        PayId: 0,
        PayName: "",
        Sn: 0,
        Status: 1,
      },
      api: require("@/api/ba/pay").default,
      rules: {
        PayName: [{ required: true, message: "付款方式名称不能为空" }],
        Sn: [{ required: true, message: "序号不能为空" }],
      },
    };
  },
  computed: {},
  methods: {
    onCreateOpened() {
      this.api.getMaxSn().then((res) => {
        this.data.Sn = res;
      });
    },
  },
};
</script>